import { useRecoilState } from 'recoil';
import { permissionAtom } from '../recoil/atoms';

export type PermissionT = {
  id: number;
  group: string;
  code: string;
  displayName: string;
};

type UsePermissionHookT = {
  permissions: PermissionT[];
  checkPermission: (permissionCodes: string[]) => boolean,
};
const usePermission = (): UsePermissionHookT => {
  const [permission] = useRecoilState(permissionAtom);

  const checkPermission = (permissionCodes: string[]): boolean => {
    if (!permission) return false;
    const userPermissions = permission.map((p: PermissionT) => p.code);
    const hasPermission = userPermissions.some(
      (userPermission: string) => (permissionCodes || []).includes(userPermission),
    );
    return !!hasPermission;
  };

  return { permissions: permission, checkPermission };
};

export default usePermission;
